"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CID_PREFIX = exports.USER_REFRESH_IMS_API = exports.IDENTITY_USERINFO = exports.COOKIE_SELECTED_ACCOUNT = exports.COOKIE_ACCESS_TOKEN = void 0;
exports.COOKIE_ACCESS_TOKEN = 'access_token';
exports.COOKIE_SELECTED_ACCOUNT = 'altus-x-account';
// load userInfo from IMS
exports.IDENTITY_USERINFO = 'api/v1/identity/userinfo';
// refresh token from IMS
exports.USER_REFRESH_IMS_API = 'api/v1/identity/user/refresh';
// cid format
exports.CID_PREFIX = 'cid:';
